import React, { useState, useRef, useEffect, useContext } from "react";
import { get, isEmpty, isNull, isUndefined, orderBy } from "lodash";
import { Form, Button, InputGroup, Image } from "react-bootstrap";
import "../../../styles/containers/CommunicationContainer.scss";
import { Formik, Field, isEmptyArray } from "formik";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import {
  ManageCommunicationLayout,
  FieldButtonGroup,
  FieldInput,
  FieldTextarea,
  FieldDropSide,
  SearchableList,
  QuillEditor,
  SliderPanel,
  DatePicker,
  DayDropdown,
  FormControlSearch,
  Dropside,
  MultiSelectDropdown,
  Link,
  EmailLayout,
  LoaderWrapper,
  AddToolTip,
  WarningModal,
  ConfigureCommunicationField,
  ContentPreviewer,
  CommunicationToSlider,
} from "../../../components";
import {
  manageCommunicationStore,
  setManageCommunicationFullPageData,
  setManageCommunicationToastInfo,
} from "../../../contexts";
import {
  manageCommunicationFormNames,
  formFields,
  MANAGE_COMMUNICATION_ROUTES,
  FLOW_TYPES,
  getPathWithParam,
  getAdvancedPathWithParam,
  usDateFormat,
  toMultiSelectValueById,
  transformToMultiselectSave,
  clearFieldValues,
  CategoryOptions,
} from "../../../utils";
import { useRouterParams, useDeepEffect, useRequest } from "../../../abstracts";
import {
  getPlanGroups,
  getPlanList,
  getEventsList,
  postSaveCommunication,
  getEmailLayout,
  getCommunicationDetailsById,
  getEmailDataById,
  deleteCommunication,
  getAdminsByPlanOrPlanGroupIds,
  getSponsorsByPlanOrPlanGroupIds,
} from "../../../services";
import weekdays from "../../../mocks/weekdays.json";
import months from "../../../mocks/months.json";
import days from "../../../mocks/days.json";
import InfiniteScroll from "react-infinite-scroller";
import DocumentAttachment from "../../../components/DocumentAttachment";
import { isNullOrUndefined } from "@microsoft/applicationinsights-core-js";

const labelOptions = [
  {
    label: "Email",
    value: 1,
  },
  // {
  //   label: "SMS",
  //   value: 2,
  // },
];
const levelOptions = [
  {
    label: "Global",
    value: 1,
  },
  {
    label: "Plan Group",
    value: 3,
  },
  {
    label: "Plan Level",
    value: 2,
  },
];

const frequencyOptions = [
  {
    label: "Daily",
    value: 1,
  },
  {
    label: "Weekly",
    value: 2,
  },
  {
    label: "Bi-weekly",
    value: 8,
  },
  {
    label: "Semi-monthly",
    value: 3,
  },
  {
    label: "Monthly",
    value: 4,
  },
  {
    label: "Quarterly",
    value: 5,
  },
  {
    label: "Semi-annually",
    value: 6,
  },
  {
    label: "Annually",
    value: 7,
  },
];

const customBreadCrumbs = [
  {
    label: "Manage Communication",
    link: MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_INFO,
  },
];

const CommunicationInfoContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(manageCommunicationStore);
  const [showEditor, setShowEditor] = useState(false);
  const [selectedImage, setSelectedImage] = useState();
  const [filteredImage, setFilteredImage] = useState([]);
  const [showLayout, setShowLayout] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [direction, setDirection] = useState("row");
  const [planList, setPlanList] = useState([]);
  const [planGroup, setPlanGroup] = useState([]);
  const [eventsList, setEventsList] = useState([]);
  const [communicationName, setCommunicationName] = useState("");
  const [textInput, setTextInput] = useState({
    chips: [],
    inputText: "",
  });
  const [textInput1, setTextInput1] = useState({
    chips: [],
    inputText: "",
  });
  const [attachmentDocHidden, setattachmentDocHidden] = useState(true);
  const formikreference = useRef(null);
  const formName = manageCommunicationFormNames.COMMUNICATION_INFO;
  const { flow, communicationId, fromPage } = useRouterParams();
  const fields = formFields[formName];
  const [data, setData] = useState("");
  const [formValues, setFormValues] = useState({});
  const [uploadDate, setUploadDate] = useState([]);
  const [metaData, setMetaData] = useState([]);
  const [loading, setLoading] = useState(false);
  const intCommunicationId = parseInt(communicationId, 10);
  const [communicationToField, setCommunicationToField] = useState([]);
  const [communicationCcField, setCommunicationCcField] = useState([]);
  const [images, setImages] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  const [isSelectedAllPlanSponsor, setIsSelectedAllPlanSponsor] = useState(
    formValues?.sendTo?.isGlobalPlanSponsors ?? false
  );
  const [isSelectedAllParticipant, setIsSelectedAllParticipant] = useState(
    formValues?.sendTo?.isGlobalPlanParticipants ?? false
  );
  const [isSelectedAllPlanAdmin, setIsSelectedAllPlanAdmin] = useState(
    formValues?.sendTo?.isGlobalPlanAdmins ?? false
  );
  const [isSelectedAllPlanSponsorCc, setIsSelectedAllPlanSponsorCc] = useState(
    formValues?.cc?.isGlobalPlanSponsors ?? false
  );
  const [isSelectedAllParticipantCc, setIsSelectedAllParticipantCc] = useState(
    formValues?.cc?.isGlobalPlanParticipants ?? false
  );
  const [isSelectedAllPlanAdminCc, setIsSelectedAllPlanAdminCc] = useState(
    formValues?.cc?.isGlobalPlanAdmins ?? false
  );
  const [isUploadSuccess, setIsUploadSuccess] = useState(true);
  const [allPlanAdmin, setAllPlanAdmin] = useState([]);
  const [allSponsorData, setAllSponsorData] = useState([]);
  const [isDisplayCommunicationTo, setDisplayCommunicationTo] = useState(false);
  const [isDisplayCommunicationCc, setDisplayCommunicationCc] = useState(false);
  const [isCommunicationTo, setIsCommunicationTo] = useState(false);
  const [dataCommunicationTo, setDataCommunicationTo] = useState({
    isSelectedAllParticipant: false,
    isSelectedAllPlanSponsor: false,
    isSelectedAllPlanAdmin: false,
  });
  const [dataCommunicationToCc, setDataCommunicationToCc] = useState({
    isSelectedAllParticipantCc: false,
    isSelectedAllPlanSponsorCc: false,
    isSelectedAllPlanAdminCc: false,
  });
  const [isCommunicationCc, setIsCommunicationCc] = useState(false);
  const [isCommunicationSubject, setIsCommunicationSubject] = useState(false);
  const [getMailIds, setGetMailIds] = useState([]);
  const [getMailIdsSlider, setGetMailIdsSlider] = useState([]);
  const [getMailIdsForCc, setGetMailIdsForCc] = useState([]);
  const [getMailIdsForCcSlider, setGetMailIdsForCcSlider] = useState([]);
  const selectLayoutId = useRef(0);
  const prevId = useRef(0);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const pageName = useRef("New Communication");
  const append = useRef(false);
  const numberOfRecordsToFetch = 20;
  const Dirty = useRef(false);
  const [level, setLevel] = useState(0);
  const [plans, setPlans] = useState([]);
  const [planGroups, setPlanGroups] = useState([]);
  const [subject, setSubject] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [CCError, setCCError] = useState(null);
  const [subjectErr, setSubjectErr] = useState(null);
  const [request, setRequest] = useState({
    from: 0,
    offset: numberOfRecordsToFetch,
    search: "",
  });
  const entryFromNewCommunication = get(
    state,
    "entryFromNewCommunication",
    true
  );
  const duplicateCommunicationInitialValues = get(state, "communication", {});
  const initialValues =
    !entryFromNewCommunication && !isEmpty(duplicateCommunicationInitialValues)
      ? duplicateCommunicationInitialValues
      : {
          attachmentFileUpload: [],
          eventType: 2,
        };
  const onSliderSave = (typedData, setFieldValue) => {
    setIsCommunicationTo(false);
    if (
      isSelectedAllPlanAdmin ||
      isSelectedAllPlanSponsor ||
      isSelectedAllParticipant ||
      !isEmptyArray(getMailIdsSlider) ||
      (!isNullOrUndefined(typedData) && typedData?.trim() !== "")
    ) {
      setDisplayCommunicationTo(true);
    } else {
      setDisplayCommunicationTo(false);
    }
    let adminData = getMailIdsSlider
      .filter((data) => data.sponsororAdmin == "admin")
      .map((x) => x?.id)
      .toString();
    let sponsorData = getMailIdsSlider
      .filter((data) => data.sponsororAdmin == "Sponsor")
      .map((x) => x?.id)
      .toString();
    setFieldValue("sendTo.selectedAdmins", adminData);
    setFieldValue("sendTo.selectedSponsors", sponsorData);
    setFieldValue("sendTo.typedEmails", typedData);
    setFieldValue("sendTo.isGlobalPlanSponsors", isSelectedAllPlanSponsor);
    setFieldValue("sendTo.isGlobalPlanParticipants", isSelectedAllParticipant);
    setFieldValue("sendTo.isGlobalPlanAdmins", isSelectedAllPlanAdmin);
    setGetMailIds(getMailIdsSlider);
  };

  const onCancelClick = () => {
    dispatch(
      setManageCommunicationFullPageData({
        communication: {},
      })
    );
    showWarningToast();
  };

  const onSliderSaveCc = (typedData, setFieldValue) => {
    setIsCommunicationCc(false);
    if (
      isSelectedAllPlanAdminCc ||
      isSelectedAllPlanSponsorCc ||
      isSelectedAllParticipantCc ||
      !isEmptyArray(getMailIdsForCcSlider) ||
      (!isNullOrUndefined(typedData) && typedData?.trim() !== "")
    ) {
      setDisplayCommunicationCc(true);
      let adminData = getMailIdsForCcSlider
        .filter((data) => data.sponsororAdmin == "admin")
        .map((x) => x?.id)
        .toString();
      let sponsorData = getMailIdsForCcSlider
        .filter((data) => data.sponsororAdmin == "Sponsor")
        .map((x) => x?.id)
        .toString();
      setFieldValue("cc.selectedAdmins", adminData);
      setFieldValue("cc.selectedSponsors", sponsorData);
      setFieldValue("cc.typedEmails", typedData);
      setFieldValue("cc.isGlobalPlanSponsors", isSelectedAllPlanSponsorCc);
      setFieldValue("cc.isGlobalPlanParticipants", isSelectedAllParticipantCc);
      setFieldValue("cc.isGlobalPlanAdmins", isSelectedAllPlanAdminCc);
      setGetMailIdsForCc(getMailIdsForCcSlider);
    } else {
      setDisplayCommunicationCc(false);
      setFieldValue("cc", null);
    }
  };

  const showDeleteToast = () => {
    setIsDelete(true);
  };
  const newSubjectMetaData = metaData?.map((i) => ({ label: i, value: 1 }));
  // const subjectMetaData = [
  //   { label: "{{ParticipantName}}", value: 1 },
  //   { label: "{{PlanName}}", value: 2 },
  // ];
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE, FLOW_TYPES.EDIT],
      onClick: onCancelClick,
    },
    {
      label: "Next",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.ADD],
      onClick: () => setShowLayout(true),
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
      onClick: () => {
        setIsSubmit(!isSubmit);
      },
    },
    {
      label: "Edit",
      variant: "link",
      type: "button",
      variant: "primary",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_INFO,
            pathParam: [FLOW_TYPES.SAVE, intCommunicationId],
          })
        ),
    },
    {
      label: "Delete",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () => showDeleteToast(),
    },
  ];
  const buttons1 = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () => {
        setShowEditor(false);
        setSelectedImage();
        setFilteredImage(images);
      },
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      onClick: () => {
        setIsSubmit(!isSubmit);
      },
    },
  ];
  const buttons3 = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () => {
        setShowLayout(false);
        setSelectedImage();
        setFilteredImage(images);
      },
    },
    {
      label: "Proceed",
      variant: "primary",
      type: "button",
      onClick: () => {
        selectLayoutId.current = selectedImage.id;
        openPage(selectedImage.id);
      },
      disabled: selectedImage == null ? true : false,
    },
  ];
  useEffect(() => {
    const sendToAdminData = formValues?.sendTo?.selectedAdmins?.split(",");
    const sendToSponsorsData = formValues?.sendTo?.selectedSponsors?.split(",");
    const meta = eventsList
      .find((x) => x.value === formValues?.eventId)
      ?.metaData?.split(",");
    setMetaData(meta);
    const sendToAdmin = allPlanAdmin?.filter((x) =>
      sendToAdminData?.some((a) => parseInt(a) === x.id)
    );
    const sendToSponsor = allSponsorData?.filter((x) =>
      sendToSponsorsData?.some((a) => parseInt(a) === x.id)
    );
    const sendToMail = [...sendToAdmin, ...sendToSponsor];
    setGetMailIds(sendToMail);
    setGetMailIdsSlider(sendToMail);
  }, [formValues, allPlanAdmin, allSponsorData]);

  useEffect(() => {
    const ccAdminData = formValues?.cc?.selectedAdmins?.split(",");
    const ccSponsorsData = formValues?.cc?.selectedSponsors?.split(",");
    const ccAdmin = allPlanAdmin?.filter((x) =>
      ccAdminData?.some((a) => parseInt(a) === x.id)
    );
    const ccSponsor = allSponsorData?.filter((x) =>
      ccSponsorsData?.some((a) => parseInt(a) === x.id)
    );
    const ccMail = [...ccAdmin, ...ccSponsor];
    setGetMailIdsForCc(ccMail);
    setGetMailIdsForCcSlider(ccMail);
  }, [formValues, allPlanAdmin, allSponsorData]);

  useEffect(() => {
    if (level && level != 0 && level != 1) {
      const adminPayload = {
        levelOfCommunication: level,
        planOrPlanGroupIds: (level == 2 ? plans : planGroups) ?? [],
      };
      getAdminsByPlanOrPlanGroupIds(adminPayload)
        .then((response) => setAllPlanAdmin(response))
        .catch((err) => {});
      getSponsorsByPlanOrPlanGroupIds(adminPayload)
        .then((response) => setAllSponsorData(response))
        .catch((err) => {});
    }
  }, [plans, planGroups]);
  useEffect(() => {
    getPlanList(0)
      .then((response) =>
        setPlanList(
          response.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          })
        )
      )
      .catch((error) => {});
    getPlanGroups({ from: 0, offset: 0, searchInput: "" }).then((response) =>
      setPlanGroup(
        orderBy(response, [(user) => user.name.toLowerCase()], ["asc"]).map(
          (item) => {
            return {
              label: item.name,
              value: item.id,
            };
          }
        )
      )
    );
    getEventsList().then((response) =>
      setEventsList(
        response.map((item) => {
          return {
            label: item.name,
            value: item.id,
            metaData: item.metaData,
            eventCategory: item.eventCategory,
          };
        })
      )
    );
  }, []);
  useEffect(() => {
    if (formValues?.sendTo?.isGlobalPlanParticipants) {
      setIsSelectedAllParticipant(true);
    }
  }, [formValues?.sendTo?.isGlobalPlanParticipants]);
  useEffect(() => {
    if (formValues?.sendTo?.isGlobalPlanSponsors) {
      setIsSelectedAllPlanSponsor(true);
    }
  }, [formValues?.sendTo?.isGlobalPlanSponsors]);
  useEffect(() => {
    if (formValues?.sendTo?.isGlobalPlanAdmins) {
      setIsSelectedAllPlanAdmin(true);
    }
  }, [formValues?.sendTo?.isGlobalPlanAdmins]);
  useEffect(() => {
    if (formValues?.cc?.isGlobalPlanParticipants) {
      setIsSelectedAllParticipantCc(true);
    }
  }, [formValues?.cc?.isGlobalPlanParticipants]);
  useEffect(() => {
    if (formValues?.cc?.isGlobalPlanSponsors) {
      setIsSelectedAllPlanSponsorCc(true);
    }
  }, [formValues?.cc?.isGlobalPlanSponsors]);
  useEffect(() => {
    if (formValues?.cc?.isGlobalPlanAdmins) {
      setIsSelectedAllPlanAdminCc(true);
    }
  }, [formValues?.cc?.isGlobalPlanAdmins]);
  useDeepEffect(() => {
    getEmailLayout({ ...request }).then((response) => {
      if (response?.length < numberOfRecordsToFetch)
        setStopInfiniteScroll(true);
      if (append.current) {
        setImages((prev) => [...prev, ...response]);
        setFilteredImage((prev) => [...prev, ...response]);
      } else {
        setImages(response);
        setFilteredImage(response);
      }
    });
  }, [request]);

  const onDeleteClick = () => {
    setLoading(true);
    deleteCommunication(intCommunicationId).then((response) => {
      if (response) {
        setLoading(false);
        dispatch(
          setManageCommunicationToastInfo({
            showToast: true,
            toastMessage: "Deleted successfully",
          })
        );
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_COMMUNICATION_ROUTES.COMMUNICATION,
          })
        );
      } else {
        setIsDelete(false);
        setLoading(false);
      }
    });
  };

  const onFormSubmit = (values, { setFieldError, setFieldTouched }) => {
    if (showEditor === true) setShowEditor(false);
    setLoading(true);
    const isNewPage = communicationId === flow;
    postSaveCommunication(
      {
        ...values,
        name: !isEmpty(duplicateCommunicationInitialValues)
        ? values?.name ?? ""
        : communicationName,
        eventId: values?.event,
        communicationTemplateHTML: data
          ? data
          : values.communicationTemplateHTML,
        level: values.level,
        eventTypeId: values?.type,
        emailLayoutId:
          selectLayoutId.current != 0
            ? selectLayoutId.current
            : values?.emailLayoutId,
        planMappings: values.planId
          ? values.planId?.map((x) => {
              return {
                planId: x,
                communicationId: isNewPage
                  ? 0
                  : fromPage == 1
                  ? 0
                  : intCommunicationId,
              };
            })
          : [],
        planGroupMappings: values.planGroupId
          ? values.planGroupId?.map((x) => {
              return {
                planGroupId: x,
                communicationId: isNewPage
                  ? 0
                  : fromPage == 1
                  ? 0
                  : intCommunicationId,
              };
            })
          : [],
      },
      dispatch,
      state
    )
      .then((response) => {
        if (response.isSuccessful) {
          setErrorMessage(null);
          setSubjectErr(null);
          setCCError(null);
          setLoading(false);
          var attachments = isEmptyArray(uploadDate)
            ? values.attachmentFileUpload
            : uploadDate;
          if (!isUndefined(attachments)) {
            var formData = new FormData();
            for (var i = 0; i < attachments.length; i++) {
              formData.append("communicationBlobAttachment", attachments[i]);
            }
            formData?.append(
              "communicationId",
              parseInt(response.communication.id, 10)
            );
            history.push(
              getAdvancedPathWithParam({
                path: MANAGE_COMMUNICATION_ROUTES.COMMUNICATION,
              })
            );
            dispatch(
              setManageCommunicationToastInfo({
                showToast: true,
                toastMessage: "Data saved successfully",
              })
            );
          } else {
            history.push(
              getAdvancedPathWithParam({
                path: MANAGE_COMMUNICATION_ROUTES.COMMUNICATION,
              })
            );
            dispatch(
              setManageCommunicationToastInfo({
                showToast: true,
                toastMessage: "Data saved successfully",
              })
            );
          }
        } else {
          setLoading(false);
          setShowEditor(false);
          for (var i = 0; i < response.errorMessages.length; i++) {
            var _ = response.errorMessages[i];
            setFieldTouched(_.controlName, true);
            setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
            if (_.controlName === "sendTo") {
              setErrorMessage(`${_.errorCode} : ${_.message}`);
            }
            if (_.controlName === "cc") {
              setCCError(`${_.errorCode} : ${_.message}`);
            }
            if (_.controlName == "subject") {
              setSubjectErr(`${_.errorCode} : ${_.message}`);
            }
          }
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  useDeepEffect(() => {
    if (!intCommunicationId) {
      setFormValues({
        ...initialValues,
      });
      return;
    }
    setLoading(true);
    pageName.current = "Communication Information";
    getCommunicationDetailsById(intCommunicationId).then((response) => {
      setLoading(false);
      setFormValues({
        ...response,
        id: fromPage == "1" ? 0 : intCommunicationId,
        event: response.eventId,
        eventCategory: response.eventCategory,
      });
      setLevel(response.level);
      setPlanGroups(response.planGroupMappings?.map((val) => val.planGroupId));
      setPlans(response.planMappings?.map((val) => val.planId));
      setCommunicationName(response?.name);
    });
  }, [intCommunicationId]);

  const openPage = (id) => {
    if (prevId.current?.[0] === id) {
      setShowEditor(true);
      setShowLayout(false);
      return;
    }
    getEmailDataById(id).then((response) => {
      prevId.current = id;
      setData(response.layoutHTML);
      setShowEditor(true);
      setShowLayout(false);
    });
  };

  //Since toast message at layout is blocked we are using a custom one
  const showWarningToast = () => {
    if (isEdit || !Dirty.current) {
      history.push(
        getAdvancedPathWithParam({
          path: MANAGE_COMMUNICATION_ROUTES.COMMUNICATION,
        })
      );
      return;
    }
    if (Dirty.current) setModalVisible(true);
  };

  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;

  useDeepEffect(() => {
    if (isSave) setDirection("column");
  }, [flow]);
  const setEditor = (values) => {
    setData(values.communicationTemplateHTML);
    setShowEditor(true);
  };
  const comaseparatedcommunicationBlobAttachment = formValues.communicationBlobAttachment?.split(
    ","
  );
  function getFileNameFromBlobPath(url) {
    return url?.split("/")?.pop()?.split("_")[0];
  }
  function getFileExtensionFromBlobPath(url) {
    return url
      ?.split("/")
      ?.pop()
      ?.split("_")[1]
      ?.slice(
        ((url?.split("/")?.pop()?.split("_")[1].lastIndexOf(".") - 1) >>> 0) + 2
      );
  }

  useEffect(() => {
    if (
      formValues?.sendTo?.selectedAdmins == null ||
      formValues?.sendTo?.selectedSponsors == null
    ) {
      setDisplayCommunicationTo(false);
    } else if (!isEmpty(formValues.sendTo)) {
      setDisplayCommunicationTo(true);
    }
  }, [formValues.sendTo]);

  useEffect(() => {
    if (
      formValues?.cc?.selectedAdmins == null ||
      formValues?.cc?.selectedSponsors == null
    ) {
      setDisplayCommunicationCc(false);
    } else if (!isEmpty(formValues.cc)) {
      setDisplayCommunicationCc(true);
    }
  }, [formValues.cc]);
  return (
    <>
      <Formik
        initialValues={{
          ...initialValues,
          ...formValues,
          [fields.name]: fromPage == 1 ? null : formValues.name,
          buttonName: "All",
          // [fields.name]:
          //   fromPage == 1 ? null : get(state, "communication.name", ""),
          [fields.communicationBlobAttachment]:
            formValues.communicationBlobAttachment,
          [fields.eventType]: 2,
          [fields.channel]: 1,
          [fields.planId]: formValues.planMappings?.map((val) => val.planId),
          [fields.planGroupId]: formValues.planGroupMappings?.map(
            (val) => val.planGroupId
          ),
          [fields.type]: !isEmpty(formValues)
            ? formValues.eventTypeId
            : initialValues.type,
          [fields.event]: fromPage == 1 ? null : formValues.eventId,
          // [fields.event]:
          //   fromPage == 1 ? null : get(state, "communication.eventId"),
        }}
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        innerRef={formikreference}
      >
        {({
          handleChange,
          setFieldValue,
          setValues,
          handleSubmit,
          handleSearch,
          values,
          dirty,
          ...rest
        }) => {
          Dirty.current = dirty;
          const onDaySelected = (fieldName, value) => {
            setFieldValue(fieldName, value);
          };
          const selectedPlan = values[fields.planId];
          const selectedPlanGroup = values[fields.planGroupId];
          var eventOptions = eventsList.filter(
            (x) => x.eventCategory == values.eventCategory
          );
          return (
            <LoaderWrapper isLoading={loading}>
              <Form
                autoComplete="off"
                className="h-100"
                onSubmit={handleSubmit}
                validated={!isEmpty(rest.errors)}
              >
                <ManageCommunicationLayout
                  pageName={pageName.current}
                  buttons={buttons}
                  customBreadCrumbs={customBreadCrumbs}
                  pageFlow={flow}
                  blockNavigation={true}
                  buttonAlign={isEdit ? true : false}
                >
                  <div
                    className="CommunicationInfoContainer-scrollable"
                    style={{
                      display: "flex",
                      flexDirection: `${direction}`,
                      width: "auto",
                      marginBottom: "60px",
                    }}
                  >
                    <div className="info h-100">
                      <Field
                        isRequired
                        name={fields.channel}
                        label="Channel"
                        size="xs"
                        options={labelOptions}
                        selectedValue={values[fields.channel]}
                        onChange={(value) => {
                          setFieldValue(fields.channel, value);
                        }}
                        disabled={isEdit || isSave}
                        component={FieldButtonGroup}
                      />
                      <Field
                        size="md"
                        isRequired
                        name={fields.name}
                        label={"Communication Name"}
                        type="text"
                        autoComplete="off"
                        value={values[fields.name]}
                        onChange={(e) => {
                          setFieldValue(fields.name, e?.target?.value);
                          setCommunicationName(e?.target?.value);
                        }}
                        onPaste={(e) => {
                          const pastedText = e.clipboardData.getData("text");
                          setFieldValue(fields.name, pastedText);
                          setCommunicationName(pastedText);
                          e.preventDefault();
                        }}
                        disabled={isEdit && !isSave}
                        component={FieldInput}
                      />
                      <Field
                        name={fields.description}
                        label="Communication Description"
                        className={"plan-name-value-style"}
                        autoComplete="off"
                        value={values[fields.description]}
                        onChange={handleChange}
                        disabled={isEdit && !isSave}
                        component={FieldTextarea}
                      />
                      <Field
                        size="md"
                        isRequired
                        label="Level Of Communication"
                        name={fields.levelOfCommunication}
                        value={values[fields.levelOfCommunication]}
                        disabled={isEdit || isSave}
                        options={levelOptions}
                        popupContent={
                          <SearchableList
                            //isNotTypeAhead
                            label="Select Level"
                            name={fields.levelOfCommunication}
                            selectedValue={values[fields.levelOfCommunication]}
                            onSelect={(e) => {
                              //setValues({ ...values, [fields.levelOfCommunication]: e });
                              setFieldValue(fields.levelOfCommunication, e);
                              setGetMailIds([]);
                              setGetMailIdsSlider([]);
                              setGetMailIdsForCc([]);
                              setGetMailIdsForCcSlider([]);
                              setLevel(e);
                              if (values[fields.levelOfCommunication] === 3) {
                                setFieldValue(fields.planId, []);
                                setPlans([]);
                              }
                              if (values[fields.levelOfCommunication] === 2) {
                                setFieldValue(fields.planGroupId, []);
                                setPlanGroups([]);
                              }
                              setFormValues((prevState) => ({
                                ...prevState,
                                level: e,
                              }));
                            }}
                            options={levelOptions}
                            disabled={isEdit || isSave}
                          />
                        }
                        component={FieldDropSide}
                      />
                      {/* {values[fields.levelOfCommunication] === 3
                        ? (values[fields.planId] = null)
                        : null} */}
                      {values[fields.levelOfCommunication] === 3 && 
                     
                            <Field
                              isRequired
                              communicationElementName="Plan Group Name"
                              label="Plan Group Name"
                              name={fields.planGroupId}
                              isPlanName={true}
                              value={toMultiSelectValueById(
                                selectedPlanGroup,
                                planGroup
                              )}
                              disabled={isEdit && !isSave}
                              isMultiSelect
                              popupContent={
                                <MultiSelectDropdown
                                  showSelectAll={
                                    isEdit && !isSave ? false : true
                                  }
                                  label={
                                    isEdit && !isSave ? "" : "Select Plan Group"
                                  }
                                  options={planGroup}
                                  width="300px"
                                  height="190px"
                                  maxHeight="200px"
                                  name={fields.planGroupId}
                                  onSelect={(value) => {
                                    setFieldValue(fields.planGroupId, value);
                                    const isNewPage = communicationId === flow;
                                    setPlanGroups(value);
                                    if(getMailIds == null || isEmptyArray(getMailIds)){
                                      setFormValues(prev => ({ ...prev, sendTo: null, cc: null, planGroupMappings: value?.map((x) => {
                                        return {
                                          planGroupId: x,
                                          communicationId: isNewPage
                                            ? 0
                                            : fromPage == 1
                                            ? 0
                                            : intCommunicationId,
                                        };
                                      })}));                                      
                                      //SendTo Values reset
                                      setFieldValue("sendTo", null);
                                      setGetMailIdsSlider([]);
                                      setDisplayCommunicationTo(false);
                                      setIsSelectedAllPlanSponsor(false);
                                      setIsSelectedAllParticipant(false);
                                      setIsSelectedAllPlanAdmin(false);
                                      //CC values reset
                                      setFieldValue("cc", null);
                                      setGetMailIdsForCcSlider([]);
                                      setDisplayCommunicationCc(false);
                                      setIsSelectedAllPlanSponsorCc(false);
                                      setIsSelectedAllParticipantCc(false);
                                      setIsSelectedAllPlanAdminCc(false);
                                    }
                                  }}
                                  value={values[fields.planGroupId]}
                                  disabled={isEdit && !isSave}
                                  isClear={true}
                                  isTypeAhead={!(isEdit && !isSave)}
                                  placeholder="Search Plan Group"
                                />
                              }
                              component={FieldDropSide}
                            />

                    }
                      {values[fields.levelOfCommunication] === 2 && 
                            <Field
                              isRequired
                              communicationElementName="Plan Name"
                              label="Plan Name"
                              name={fields.planId}
                              options={planList}
                              value={toMultiSelectValueById(
                                selectedPlan,
                                planList
                              )}
                              disabled={isEdit && !isSave}
                              isMultiSelect
                              isPlanName={true}
                              popupContent={
                                <MultiSelectDropdown
                                  disabled={isEdit && !isSave}
                                  showSelectAll={
                                    isEdit && !isSave ? false : true
                                  }
                                  label={
                                    isEdit && !isSave ? "" : "Select Plan Name"
                                  }
                                  width="305px"
                                  height="190px"
                                  maxHeight="200px"
                                  options={planList}
                                  name={fields.planId}
                                  overflow
                                  onSelect={(value) => {
                                    setFieldValue(fields.planId, value);
                                    setPlans(value);
                                    const isNewPage = communicationId === flow;
                                    if(getMailIds == null || isEmptyArray(getMailIds)){
                                      setFormValues(prev => ({ ...prev, sendTo: null, cc: null, planMappings: value?.map((x) => {
                                        return {
                                          planId: x,
                                          communicationId: isNewPage
                                            ? 0
                                            : fromPage == 1
                                            ? 0
                                            : intCommunicationId,
                                        };
                                      })}));
                                      //To                                      
                                      setFieldValue("sendTo", null);
                                      setGetMailIdsSlider([]);
                                      setDisplayCommunicationTo(false);
                                      setIsSelectedAllPlanSponsor(false);
                                      setIsSelectedAllParticipant(false);
                                      setIsSelectedAllPlanAdmin(false);
                                      //CC
                                      setFieldValue("cc", null);
                                      setGetMailIdsForCcSlider([]);
                                      setDisplayCommunicationCc(false);
                                      setIsSelectedAllPlanSponsorCc(false);
                                      setIsSelectedAllParticipantCc(false);
                                      setIsSelectedAllPlanAdminCc(false);
                                    }
                                  }}
                                  value={values[fields.planId]}
                                  isClear={true}
                                  isTypeAhead={!(isEdit && !isSave)}
                                  placeholder="Search Plan Name"
                                />
                              }
                              component={FieldDropSide}
                            />
                      }

                      <>
                        <div className="select-event-search">
                          <Field
                            isRequired
                            label="Event Category"
                            name={fields.eventCategory}
                            value={values[fields.eventCategory]}
                            // direction="bottom"
                            options={CategoryOptions}
                            placeholder="Select"
                            disabled={isEdit || isSave}
                            size="md"
                            popupContent={
                              <SearchableList
                                label="Select event category"
                                height="150px"
                                page="NewCommunication"
                                options={CategoryOptions}
                                name={fields.eventCategory}
                                value={values[fields.eventCategory]}
                                onSelect={(value) => {
                                  setFieldValue(fields.eventCategory, value);
                                  setFieldValue(fields.event, null);
                                }}
                              />
                            }
                            component={FieldDropSide}
                          />
                        </div>
                        {
                          <Field
                            size="md"
                            isRequired
                            label="Event Name"
                            page="New Communication"
                            name={fields.event}
                            //placeholder="Select one"
                            value={values[fields.event]}
                            disabled={isEdit || isSave}
                            options={eventOptions}
                            popupContent={
                              <SearchableList
                                isNotTypeAhead
                                label="Select an event"
                                name={fields.event}
                                disabled={isEdit && !isSave}
                                selectedValue={values[fields.event]}
                                onSelect={(e) => {
                                  setMetaData(
                                    eventsList
                                      .find((x) => x.value === e)
                                      ?.metaData?.split(",")
                                  );
                                  setFieldValue(fields.event, e);
                                }}
                                value={fields.event}
                                options={eventOptions}
                              />
                            }
                            component={FieldDropSide}
                          />
                        }
                        <div className="font-weight-bold mt-5 mb-4 user-select-none">
                          Recipient Details
                        </div>
                        <div className="label">Communication To</div>
                        {isDisplayCommunicationTo ? (
                          <>
                            <div className="d-flex">
                              <div
                                className="d-flex justify-content-space-around flex-wrap"
                                style={{
                                  maxWidth: "310px",
                                  width: "310px",
                                  padding: "10px",
                                  height: "100px",
                                  border: isNull(errorMessage)
                                    ? "2px solid #949494"
                                    : "1px solid red",
                                  cursor: "pointer",
                                  borderRadius: "5px",
                                  overflow: "scroll",
                                  backgroundColor: isEdit ? "#d3d3d3" : "white",
                                }}
                              >
                                {getMailIds.map((x) => {
                                  return (
                                    <div
                                      className="pl-2 pr-2"
                                      style={{
                                        border: "1px solid #bdbdbd",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        margin: "4px",
                                        paddingTop: "3px",
                                        height: "38px",
                                      }}
                                    >
                                      {x?.email ? x?.email : x?.planName}
                                    </div>
                                  );
                                })}
                                {isSelectedAllPlanSponsor && (
                                  <div
                                    className="p-2 m-1 text-center"
                                    style={{
                                      border: "1px solid #bdbdbd",
                                      borderRadius: "5px",
                                      height: "40px",
                                    }}
                                  >
                                    All Sponsors
                                  </div>
                                )}
                                {isSelectedAllParticipant && (
                                  <div
                                    className="p-2 m-1 text-center"
                                    style={{
                                      border: "1px solid #bdbdbd",
                                      borderRadius: "5px",
                                      height: "40px",
                                    }}
                                  >
                                    All Participants
                                  </div>
                                )}
                                {isSelectedAllPlanAdmin && (
                                  <div
                                    className="p-2 m-1 text-center"
                                    style={{
                                      border: "1px solid #bdbdbd",
                                      borderRadius: "5px",
                                      height: "40px",
                                    }}
                                  >
                                    All Admin
                                  </div>
                                )}
                                {!isNullOrUndefined(
                                  values?.sendTo?.typedEmails
                                ) &&
                                  values?.sendTo?.typedEmails !== "" &&
                                  values?.sendTo?.typedEmails
                                    .split(",")
                                    .map((x) => {
                                      return (
                                        <div
                                          className="p-2 m-1 text-center"
                                          style={{
                                            border: "1px solid #bdbdbd",
                                            borderRadius: "5px",
                                            height: "40px",
                                          }}
                                        >
                                          {x}
                                        </div>
                                      );
                                    })}
                              </div>
                              {!isEdit && (
                                <div
                                  style={{
                                    width: "10%",
                                    paddingLeft: "10px",
                                  }}
                                  onClick={() => {
                                    if (!isEdit) {
                                      setDataCommunicationTo({
                                        isSelectedAllParticipant: isSelectedAllParticipant,
                                        isSelectedAllPlanSponsor: isSelectedAllPlanSponsor,
                                        isSelectedAllPlanAdmin: isSelectedAllPlanAdmin,
                                      });
                                      setIsCommunicationTo(true);
                                      setFieldValue("buttonName", "All");
                                    }
                                  }}
                                >
                                  <i
                                    className="fal fa-pen-square primary-color"
                                    style={{
                                      fontSize: "1.5em",
                                    }}
                                  ></i>
                                </div>
                              )}
                            </div>
                            {!isNull(errorMessage) && (
                              <div className="error-message mt-md-3">
                                {errorMessage}
                              </div>
                            )}
                          </>
                        ) : (
                          <ConfigureCommunicationField
                            data="Add recipients (To)"
                            width={isSave ? "20%" : "240px"}
                            border={
                              isNull(errorMessage)
                                ? "2px solid #949494"
                                : "1px solid red"
                            }
                            padding="10px"
                            borderRadius="5px"
                            errorMessage={errorMessage}
                            backgroundColor={isEdit ? "#d3d3d3" : "white"}
                            onClickNavigate={() => {
                              if (!isEdit) {
                                setDataCommunicationTo({
                                  isSelectedAllParticipant: isSelectedAllParticipant,
                                  isSelectedAllPlanSponsor: isSelectedAllPlanSponsor,
                                  isSelectedAllPlanAdmin: isSelectedAllPlanAdmin,
                                });
                                setIsCommunicationTo(true);
                                setFieldValue("buttonValue", "Admin");
                              }
                            }}
                          />
                        )}
                        {/* <Field
                        size="md"
                        name={fields.cc}
                        label={"Communication cc"}
                        type="text"
                        autoComplete="off"
                        value={values[fields.cc]}
                        onChange={handleChange}
                        disabled={isEdit && !isSave}
                        component={FieldInput}
                      /> */}
                        <div className="label mt-3">
                          Communication CC (Optional)
                        </div>
                        {isDisplayCommunicationCc ? (
                          <>
                            <div className="d-flex">
                              <div
                                className="d-flex justify-content-space-around flex-wrap"
                                style={{
                                  width: "310px",
                                  padding: "10px",
                                  height: "100px",
                                  border: isNull(CCError)
                                    ? "2px solid #949494"
                                    : "1px solid red",
                                  cursor: "pointer",
                                  borderRadius: "5px",
                                  overflow: "scroll",
                                  backgroundColor: isEdit ? "#d3d3d3" : "white",
                                }}
                              >
                                <>
                                  {getMailIdsForCc.map((x) => {
                                    return (
                                      <div
                                        className="pl-2 pr-2"
                                        style={{
                                          border: "1px solid #bdbdbd",
                                          borderRadius: "5px",
                                          cursor: "pointer",
                                          margin: "4px",
                                          paddingTop: "3px",
                                          height: "38px",
                                        }}
                                      >
                                        {x?.email ? x?.email : x?.planName}
                                      </div>
                                    );
                                  })}
                                  {isSelectedAllPlanSponsorCc && (
                                    <div
                                      className="p-2 m-1 text-center"
                                      style={{
                                        border: "1px solid #bdbdbd",
                                        borderRadius: "5px",
                                        height: "40px",
                                      }}
                                    >
                                      All Sponsors
                                    </div>
                                  )}
                                  {isSelectedAllParticipantCc && (
                                    <div
                                      className="p-2 m-1 text-center"
                                      style={{
                                        border: "1px solid #bdbdbd",
                                        borderRadius: "5px",
                                        height: "40px",
                                      }}
                                    >
                                      All Participant
                                    </div>
                                  )}
                                  {isSelectedAllPlanAdminCc && (
                                    <div
                                      className="p-2 m-1 text-center"
                                      style={{
                                        border: "1px solid #bdbdbd",
                                        borderRadius: "5px",
                                        height: "40px",
                                      }}
                                    >
                                      All Admin
                                    </div>
                                  )}
                                  {values?.cc?.typedEmails !== "" &&
                                    values?.cc?.typedEmails
                                      ?.split(",")
                                      .map((x) => {
                                        return (
                                          <div
                                            className="p-2 m-1 text-center"
                                            style={{
                                              border: "1px solid #bdbdbd",
                                              borderRadius: "5px",
                                              height: "40px",
                                            }}
                                          >
                                            {x}
                                          </div>
                                        );
                                      })}
                                </>
                              </div>
                              <div
                                style={{
                                  width: "10%",
                                  paddingLeft: "10px",
                                }}
                                onClick={() => {
                                  if (!isEdit) {
                                    setDataCommunicationToCc({
                                      isSelectedAllParticipantCc: isSelectedAllParticipantCc,
                                      isSelectedAllPlanSponsorCc: isSelectedAllPlanSponsorCc,
                                      isSelectedAllPlanAdminCc: isSelectedAllPlanAdminCc,
                                    });
                                    setIsCommunicationCc(true);
                                    setFieldValue("buttonName", "All");
                                  }
                                }}
                              >
                                {!isEdit && (
                                  <i
                                    className="fal fa-pen-square primary-color"
                                    style={{
                                      fontSize: "1.5em",
                                    }}
                                  ></i>
                                )}
                              </div>
                            </div>
                            {!isNull(CCError) && (
                              <div className="error-message mt-md-3">
                                {CCError}
                              </div>
                            )}
                          </>
                        ) : (
                          <ConfigureCommunicationField
                            data="Add recipients (CC)"
                            width={isSave ? "20%" : "240px"}
                            // border="2px solid #949494"
                            border={
                              isNull(CCError)
                                ? "2px solid #949494"
                                : "1px solid red"
                            }
                            padding="10px"
                            borderRadius="5px"
                            backgroundColor={isEdit ? "#d3d3d3" : "white"}
                            onClickNavigate={() => {
                              if (!isEdit) {
                                setDataCommunicationToCc({
                                  isSelectedAllParticipantCc: isSelectedAllParticipantCc,
                                  isSelectedAllPlanSponsorCc: isSelectedAllPlanSponsorCc,
                                  isSelectedAllPlanAdminCc: isSelectedAllPlanAdminCc,
                                });
                                setIsCommunicationCc(true);
                                setFieldValue("buttonName", "All");
                              }
                            }}
                          />
                        )}
                        <div className="label mt-3">Subject</div>
                        {isEmpty(values.subject) ? (
                          <>
                            <ConfigureCommunicationField
                              data="Add subject"
                              width={isSave ? "20%" : "240px"}
                              // border="2px solid #949494"
                              padding="10px"
                              border={
                                isNull(subjectErr)
                                  ? "2px solid #949494"
                                  : "1px solid red"
                              }
                              borderRadius="5px"
                              backgroundColor={isEdit ? "#d3d3d3" : "white"}
                              onClickNavigate={() => {
                                if (!isEdit) setIsCommunicationSubject(true);
                                setSubject(values.subject);
                              }}
                            />
                            {!isNull(subjectErr) && (
                              <div className="error-message mt-md-3">
                                {subjectErr}
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="d-flex justify-content-space-around flex-wrap">
                            <div
                              style={{
                                width: "310px",
                                padding: "10px",
                                //height: "36px",
                                maxHeight: "90px",
                                border: "2px solid #949494",
                                cursor: "pointer",
                                borderRadius: "5px",
                                display: "flex",
                                flexDirection: "column",
                                backgroundColor: isEdit ? "#d3d3d3" : "white",
                                overflow: "scroll",
                              }}
                            >
                              <div
                                style={{
                                  width: "85%",
                                  height: "80px",
                                }}
                              >
                                {values.subject}
                              </div>
                            </div>
                            <div style={{ paddingLeft: "10px" }}>
                              {!isEdit && (
                                <i
                                  className="fal fa-pen-square primary-color"
                                  style={{
                                    fontSize: "1.5em",
                                  }}
                                  onClick={() => {
                                    if (!isEdit)
                                      setIsCommunicationSubject(true);
                                    setSubject(values.subject);
                                  }}
                                ></i>
                              )}
                            </div>
                          </div>
                        )}
                        {/* <div className="label mt-3">Attachments (Optional)</div>
                        <div
                          style={{
                            height: "30%",
                            width: "30%",
                            marginBottom:
                              isEdit ||
                              window.location.pathname
                                .split("/")
                                .includes("add")
                                ? "70px"
                                : "0px",
                          }}
                        >
                          <DocumentAttachment
                            isUploadSuccess={isUploadSuccess}
                            // uploadDate={uploadDate}
                            comaseparatedcommunicationBlobAttachment={
                              comaseparatedcommunicationBlobAttachment
                            }
                            // setUploadDate={setUploadDate}
                            setFieldValue={setFieldValue}
                            enablePreview={true}
                            name={fields.attachmentFileUpload}
                            fileExtensions=".jpeg, .png, .jpg, .pdf, .doc, .docx"
                            values={values}
                            responseModel={formValues}
                            documentHidden={attachmentDocHidden}
                            setDocumentHidden={setattachmentDocHidden}
                          />
                        </div> */}
                      </>
                    </div>
                    {isEdit ? (
                      <div className="pic h-100 w-100">
                        <p className="p1">Preview</p>
                        <p className="p2">{values?.emailLayoutName}</p>
                        <div className="previewImage">
                          <img
                            src={values?.communicationTemplateImagePath}
                            style={{
                              height: "85%",
                              objectFit: "fill",
                              width: "100%",
                            }}
                          />
                        </div>
                      </div>
                    ) : isSave ? (
                      <>
                        <p
                          className={
                            values.type !== 1
                              ? "pelement mt-3"
                              : "pelement mt-15"
                          }
                        >
                          Layout name
                        </p>
                        <a
                          className="h80-cursor mb-2"
                          onClick={() => setEditor(values)}
                        >
                          {values?.emailLayoutName}
                        </a>
                      </>
                    ) : null}
                  </div>
                  <SliderPanel isOpen={showEditor} size="85" showCancel={false}>
                    <div
                      className="mr-600"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ width: "1200px" }}>
                        <ManageCommunicationLayout
                          pageName="Communication Content"
                          buttons={buttons1}
                          blockNavigation={true}
                          overflow={"paddingRight:5%"}
                        >
                          <div className="Container">
                            <div
                              style={{
                                display: "block",
                                textAlign: "right",
                                padding: "10px",
                              }}
                            >
                              <a
                                href="#"
                                onClick={() => {
                                  setShowEditor(false);
                                  setShowLayout(true);
                                }}
                              >
                                Change Layout
                              </a>
                            </div>
                            <QuillEditor
                              data={data}
                              isSubmit={isSubmit}
                              setData={setData}
                              value={data}
                              metaData={metaData}
                              values={values}
                              name={fields.communicationTemplateHTML}
                            />
                          </div>
                        </ManageCommunicationLayout>
                      </div>
                    </div>
                  </SliderPanel>
                  <SliderPanel
                    header="Communication To"
                    showHeader={true}
                    headerClass="ct-slider-header"
                    isOpen={isCommunicationTo}
                    size="72"
                    showSave={true}
                    showCancelButton={false}
                    onSave={() => {
                      onSliderSave(
                        textInput?.inputText?.toString(),
                        setFieldValue
                      );
                    }}
                    onClose={() => {
                      setIsSelectedAllParticipant(
                        dataCommunicationTo.isSelectedAllParticipant
                      );
                      setIsSelectedAllPlanSponsor(
                        dataCommunicationTo.isSelectedAllPlanSponsor
                      );
                      setIsSelectedAllPlanAdmin(
                        dataCommunicationTo.isSelectedAllPlanAdmin
                      );
                      setGetMailIdsSlider(getMailIds);
                      setIsCommunicationTo(false);
                    }}
                    flair="communication-slider"
                  >
                    <CommunicationToSlider
                      // getAdmin={formValues?.sendTo?.selectedAdmins}
                      // getSponsor={formValues?.sendTo?.selectedSponsors}
                      textInput={textInput}
                      setTextInput={setTextInput}
                      getMailIds={getMailIdsSlider}
                      setGetMailIds={setGetMailIdsSlider}
                      setCommunicationToField={setCommunicationToField}
                      communicationToField={communicationToField}
                      allPlanAdmin={allPlanAdmin}
                      allSponsorData={allSponsorData}
                      // panelName={"Communication To"}
                      isSelectedAllPlanSponsor={isSelectedAllPlanSponsor}
                      setIsSelectedAllPlanSponsor={setIsSelectedAllPlanSponsor}
                      isSelectedAllParticipant={isSelectedAllParticipant}
                      setIsSelectedAllParticipant={setIsSelectedAllParticipant}
                      isSelectedAllPlanAdmin={isSelectedAllPlanAdmin}
                      setIsSelectedAllPlanAdmin={setIsSelectedAllPlanAdmin}
                      values={values}
                      setFieldValue={setFieldValue}
                      getTextInput={
                        !isNullOrUndefined(textInput?.inputText) &&
                        textInput?.inputText.trim() != ""
                          ? textInput?.inputText
                          : formValues?.sendTo?.typedEmails
                      }
                    />
                  </SliderPanel>
                  <SliderPanel
                    header="Communication CC"
                    showHeader={true}
                    headerClass="ct-slider-header"
                    isOpen={isCommunicationCc}
                    size="72"
                    showSave={true}
                    showCancelButton={false}
                    onSave={() => {
                      onSliderSaveCc(
                        textInput1?.inputText?.toString(),
                        setFieldValue
                      );
                    }}
                    onClose={() => {
                      setIsSelectedAllParticipantCc(
                        dataCommunicationToCc.isSelectedAllParticipantCc
                      );
                      setIsSelectedAllPlanAdminCc(
                        dataCommunicationToCc.isSelectedAllPlanAdminCc
                      );
                      setIsSelectedAllPlanSponsorCc(
                        dataCommunicationToCc.isSelectedAllPlanSponsorCc
                      );
                      setGetMailIdsForCcSlider(getMailIdsForCc);
                      setIsCommunicationCc(false);
                    }}
                    flair="communication-slider"
                  >
                    <CommunicationToSlider
                      // getAdmin={formValues?.cc?.selectedAdmins}
                      // getSponsor={formValues?.cc?.selectedSponsors}
                      textInput={textInput1}
                      setTextInput={setTextInput1}
                      getMailIds={getMailIdsForCcSlider}
                      setGetMailIds={setGetMailIdsForCcSlider}
                      setCommunicationToField={setCommunicationCcField}
                      communicationToField={communicationCcField}
                      allPlanAdmin={allPlanAdmin}
                      allSponsorData={allSponsorData}
                      // panelName={"Communication CC"}
                      isSelectedAllPlanSponsor={isSelectedAllPlanSponsorCc}
                      setIsSelectedAllPlanSponsor={
                        setIsSelectedAllPlanSponsorCc
                      }
                      isSelectedAllParticipant={isSelectedAllParticipantCc}
                      setIsSelectedAllParticipant={
                        setIsSelectedAllParticipantCc
                      }
                      isSelectedAllPlanAdmin={isSelectedAllPlanAdminCc}
                      setIsSelectedAllPlanAdmin={setIsSelectedAllPlanAdminCc}
                      values={values}
                      setFieldValue={setFieldValue}
                      getTextInput={
                        !isNullOrUndefined(textInput1?.inputText) &&
                        textInput1?.inputText.trim() != ""
                          ? textInput1?.inputText
                          : formValues?.cc?.typedEmails
                      }
                    />
                  </SliderPanel>

                  <SliderPanel
                    isOpen={isCommunicationSubject}
                    size="40"
                    showSave={true}
                    showHeader={true}
                    header="Communication Subject"
                    headerClass="ct-slider-header"
                    showCancelButton={true}
                    showCancel={false}
                    // showCancelButton={true}
                    // showBackButton={false}
                    onSave={() => {
                      setIsCommunicationSubject(false);
                      // setFormValues((prevState) => ({
                      //   ...prevState,
                      //   subject: values[fields.subject],
                      // }));
                    }}
                    onClose={() => {
                      setIsCommunicationSubject(false);
                      setFieldValue(fields.subject, subject);
                    }}
                  >
                    <div>
                      {/* <div className="communicationTo-header">
                        Communication Subject
                      </div> */}
                      <hr className="CommunicationTo-horizontal mb-4"></hr>
                      <div
                        className="communicationTo-border"
                        style={{ height: "530px" }}
                      >
                        <div className="d-flex justify-content-space-between">
                          <h5 className="fw-500">Editor</h5>
                          <div>
                            <Field
                              size="md"
                              isRequired
                              isNotTypeAhead
                              name={fields.subjectMetaData}
                              value={values[fields.subjectMetaData]}
                              direction="bottom"
                              placeholder="Select Meta-Data"
                              disabled={isEdit && !isSave}
                              options={newSubjectMetaData}
                              popupContent={
                                <SearchableList
                                  isNotTypeAhead
                                  label="Select Meta-Data"
                                  width=""
                                  name={fields.subjectMetaData}
                                  selectedValue={values[fields.subjectMetaData]}
                                  onSelect={(e, label) => {
                                    setFieldValue(
                                      fields.subjectMetaData,
                                      label
                                    );
                                    setFieldValue(
                                      fields.subject,
                                      values[fields.subject]
                                        ? values[fields.subject] + " " + label
                                        : label
                                    );
                                  }}
                                  value={fields.subjectMetaData}
                                  options={newSubjectMetaData}
                                  disabled={isEdit && !isSave}
                                />
                              }
                              component={FieldDropSide}
                            />
                          </div>
                        </div>
                        <hr className="CommunicationTo-horizontal mb-4"></hr>
                        <Field
                          name={fields.subject}
                          component={FieldTextarea}
                          rows={15}
                          disabled={isEdit && !isSave}
                          onChange={handleChange}
                          style={{
                            minWidth: "100%",
                            border: "1px solid #ffffff",
                          }}
                          value={values[fields.subject]}
                        />
                      </div>
                    </div>
                  </SliderPanel>
                </ManageCommunicationLayout>
              </Form>
            </LoaderWrapper>
          );
        }}
      </Formik>

      <SliderPanel
        backdropClicked={() => setShowEditor(false)}
        isOpen={showLayout}
        size="77"
        showCancel={false}
      >
        <div>
          <ManageCommunicationLayout
            pageName="Choose E-Mail Layout"
            buttons={buttons3}
            blockNavigation={true}
            buttonAlign={isEdit ? true : false}
          >
            <div className="choose-layout">
              <div className="header1 slide-head">
                <p className="gr mb-6">Search</p>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text className="plan-search-button">
                      <Image src="/assets/icons/svg/search.svg" width="14px" />
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControlSearch
                    size="md"
                    type="search"
                    // className="plan-search-box pad-left-search"
                    placeholder="Search E-Mail Layout"
                    onChange={(e) => {
                      const value = e?.target?.value;
                      append.current = false;
                      setRequest((prevRequest) => ({
                        ...prevRequest,
                        search: value,
                      }));
                    }}
                  />
                </InputGroup>
                {filteredImage && filteredImage.length !== 0 ? (
                  <div
                    // style={{ marginLeft: "305px" }}
                    className="header2-communication"
                  >
                    <p className="core-body-text-small-semi-bold">
                      {filteredImage.length} E-Mail Layouts found
                    </p>
                  </div>
                ) : null}
                <div style={{ overflowY: "scroll", maxHeight: "500px" }}>
                  <InfiniteScroll
                    pageStart={0}
                    loadMore={() => {
                      append.current = true;
                      setRequest(() => ({
                        ...request,
                        from: filteredImage?.length,
                      }));
                    }}
                    hasMore={!stopInfiniteScroll}
                    initialLoad={false}
                    //threshold={100}
                    useWindow={false}
                    loader={
                      <div className="loader" key={0}>
                        Loading ...
                      </div>
                    }
                  >
                    <div className="flex-wrap">
                      {filteredImage.length > 0 ? (
                        filteredImage.map((x, index) => {
                          return (
                            <Link
                              onClick={() => {
                                setSelectedImage(x);
                              }}
                              style={{ textDecoration: "none" }}
                            >
                              {" "}
                              <div className="mr-10">
                                <Image
                                  src={x.imagePath}
                                  width="140"
                                  height="140"
                                  className="img-border"
                                />
                                <p style={{ paddingBottom: "15px" }}>
                                  {x.layoutName.length > 15 ? (
                                    <AddToolTip
                                      className="link-text core-body-text-large-medium"
                                      name={x.layoutName}
                                      placement="bottom"
                                    >
                                      {(x.layoutName || "").slice(0, 15)}...
                                    </AddToolTip>
                                  ) : (
                                    <p className="link-text core-body-text-large-medium">
                                      {x.layoutName}
                                    </p>
                                  )}
                                </p>
                              </div>
                            </Link>
                          );
                        })
                      ) : (
                        <span
                          style={{
                            margin: "auto",
                            fontSize: "18px",
                            color: "#333333",
                            paddingTop: "71px",
                          }}
                        >
                          No Records Found
                        </span>
                      )}
                    </div>
                  </InfiniteScroll>
                </div>
              </div>
              <div className="header2-right-communication">
                <div className="element1">
                  <div className="element2 core-heading-regular ">Preview</div>
                  {/* {selectedImage != null && (
                    <div>
                      <Button
                        variant="primary"
                        onClick={() => {
                          selectLayoutId.current = selectedImage.id;
                          openPage(selectedImage.id);
                        }}
                      >
                        Proceed
                      </Button>
                    </div>
                  )} */}
                </div>
                <div className="mt-30">
                  {selectedImage != null && (
                    <Image
                      src={selectedImage.imagePath}
                      width="550"
                      height="463"
                      // className="img-border"
                    />
                  )}
                </div>
              </div>
            </div>
          </ManageCommunicationLayout>
        </div>
      </SliderPanel>
      <WarningModal show={modalVisible} onHide={() => setModalVisible(false)}>
        <div className="remove-text">
          <h4>Are you sure?</h4>
          <p>Your changes may be lost. Do you want to continue ?</p>
          <Button
            type="button"
            className="remove-btn mr-4 "
            onClick={() =>
              history.push(
                getAdvancedPathWithParam({
                  path: MANAGE_COMMUNICATION_ROUTES.COMMUNICATION,
                })
              )
            }
          >
            Yes
          </Button>
          <Button
            className="cancel-btn "
            onClick={() => setModalVisible(false)}
          >
            No
          </Button>
        </div>
      </WarningModal>
      <WarningModal show={isDelete} onHide={() => setIsDelete(false)}>
        <div className="remove-text">
          <h4>Are you sure? </h4>
          <p>The communication will be deleted and removed from the schedule</p>
          <Button
            type="button"
            className="remove-btn mr-4 "
            onClick={() => {
              onDeleteClick();
            }}
          >
            Yes
          </Button>
          <Button
            className="cancel-btn mr-4 "
            onClick={() => setIsDelete(false)}
          >
            Cancel
          </Button>
          <Button className="cancel-btn " onClick={() => setIsDelete(false)}>
            No
          </Button>
        </div>
      </WarningModal>
    </>
  );
};

export default CommunicationInfoContainer;
